import React, { useState, useEffect } from 'react';

import { Button, ButtonProps } from 'semantic-ui-react';

interface Props extends ButtonProps {
  onClick: () => Promise<void>;
  children: React.ReactNode;
  disabled?: boolean;
}

function OhsDebouncedButton({ onClick, children, disabled, ...rest }: Props) {
  const [clicked, setClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (!clicked && !isLoading) {
      setIsLoading(true);
      setClicked(true);
      await onClick();

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (!isLoading && clicked) {
      setClicked(false);
    }
  }, [isLoading]);

  return (
    <Button
      onClick={handleClick}
      disabled={clicked || isLoading || disabled}
      loading={isLoading}
      {...rest}
    >
      {children}
    </Button>
  );
}

OhsDebouncedButton.defaultProps = {
  disabled: false,
};

export default OhsDebouncedButton;
